
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Stars, Preload } from "@react-three/drei";
import Planet from "./Planet";
import { Suspense } from "react";

const SpaceScene = () => {
  return (
    <div className="w-full h-full absolute inset-0 z-0">
      <Canvas camera={{ position: [0, 0, 15], fov: 50 }}>
        <Suspense fallback={null}>
          {/* Ambient light for overall scene illumination */}
          <ambientLight intensity={0.2} />
          
          {/* Main directional light to simulate sun */}
          <directionalLight
            position={[5, 3, 5]}
            intensity={1.2}
            color="#ffffff"
          />
          
          {/* Soft blue backlight */}
          <directionalLight
            position={[-5, -2, -5]}
            intensity={0.6}
            color="#b0c4de"
          />
          
          {/* Additional point lights for particle glow effect */}
          <pointLight position={[10, 5, 10]} intensity={0.8} color="#4fc3f7" />
          <pointLight position={[-10, -5, -10]} intensity={0.5} color="#4fc3f7" />
          
          {/* Planet component with particle effect */}
          <Planet
            position={[0, 0, 0]}
            size={4} 
            rotationSpeed={0.0005} 
          />
          
          {/* Stars background */}
          <Stars
            radius={100}
            depth={50}
            count={5000}
            factor={4}
            saturation={0}
            fade
            speed={0.3}
          />
          
          {/* Camera controls */}
          <OrbitControls
            enableZoom={true}
            enablePan={false}
            enableRotate={true}
            autoRotate={false}
            autoRotateSpeed={0.1}
            minDistance={8}
            maxDistance={20}
            minPolarAngle={Math.PI / 2 - 1.2} 
            maxPolarAngle={Math.PI / 2 + 1.2}
          />
          
          <Preload all />
        </Suspense>
      </Canvas>
    </div>
  );
};

export default SpaceScene;
